import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import {
  Organization,
  useOrganizationsTableContext,
} from '../../../../OrganizationsTableContext'
import {
  EditOrganizationModalBody,
  EditOrganizationModalValues,
} from './components/EditOrganizationModalBody'
import { useEditOrganizationMutation } from 'schema'

export function useEditOptions(): EditRowActionOptions<
  Organization,
  EditOrganizationModalValues
> {
  const { refetch } = useOrganizationsTableContext()
  const [editOrganization] = useEditOrganizationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editDSOrganization: {
        organization: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditDesignSubmittalOrganization,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <EditOrganizationModalBody />,
      initialValues: ({ name, description }) => {
        return { name, description: description }
      },
      onOk: async ({ id, ...submittal }, { name, description }) => {
        if (submittal.name !== name || submittal.description !== description) {
          await editOrganization({
            variables: { editOrganizationInput: { id, name, description } },
          })
          await refetch()
        }
      },
    },
  }
}
